export default "__VITE_ASSET__CN4AUS9P__"